import dayjs from 'dayjs'

export const toApiDate = (value: string): string => dayjs(value).format('YYYY-MM-DD')
